import { useLocation, useNavigate } from "react-router-dom";

const GuestHeader = ({ displayName = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="bg-white dark:bg-gray-900 rounded-md shadow-md sticky top-0 z-50">
      <div className=" mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap md:flex-nowrap items-center justify-between py-4 md:h-16 gap-4">
          {/* Logo Left */}
          <div className="flex-shrink-0 flex items-center">
            <img
              className="h-8 w-auto sm:h-10"
              src="/Caprock-Logo2.svg"
              alt="Company Logo"
            />
          </div>

          {/* Right Side - Login Button & Profile */}
          <div className="flex items-center gap-4 ml-auto">
            {/* Login Button */}
            <button
              className="flex items-center space-x-2 bg-black text-white px-4 py-2 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition"
              onClick={() => {
                navigate("/login", {
                  state: {
                    from: location.pathname,
                    historyStack: [
                      ...(location.state?.historyStack || []),
                      location.pathname,
                    ],
                  },
                });
              }}
            >
              <img
                src="/profile-circle-white.svg"
                alt="Login"
                className="w-4 h-4"
              />
              <span className="text-sm font-medium hidden lg:inline">
                Login
              </span>
            </button>
            <button
              disabled={true}
              className="flex items-center space-x-2 bg-white px-4 py-2 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition"
              onClick={() => {
                navigate("/login", {
                  state: {
                    from: location.pathname,
                    historyStack: [
                      ...(location.state?.historyStack || []),
                      location.pathname,
                    ],
                  },
                });
              }}
            >
              <img src="/user-circle-add.svg" alt="Login" className="w-4 h-4" />
              <span className="text-sm font-medium hidden lg:inline">
                Sign up
              </span>
            </button>
            {/* Profile Section */}
            <div className="flex items-center space-x-2 bg-white rounded-xl p-2 shadow-md">
              <img
                src="/avatar.svg"
                alt="User Avatar"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
              />
              <div className="hidden sm:block text-sm whitespace-nowrap">
                <p className="font-medium text-[#005A9C]">Welcome</p>
                <p className="text-black">{displayName || "Guest"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default GuestHeader;
